module.exports = __webpack_public_path__ + "img/dianhua.9bcc07d7.svg";